export function buildUserRoleTagView(role) {
  if (role === 'admin') {
    return {
      label: '管理员',
      className: 'bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100',
    };
  }
  if (role === 'ceo') {
    return {
      label: '总裁',
      className: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100',
    };
  }
  if (role === 'groupLeader') {
    return {
      label: '审计组长',
      className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
    };
  }
  return {
    label: '普通用户',
    className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
  };
}

export function formatUserLastActive(lastActiveAt, nowTs = Date.now()) {
  if (!lastActiveAt) return '暂无活跃记录';
  const ts = new Date(lastActiveAt).getTime();
  if (Number.isNaN(ts)) return '暂无活跃记录';
  const diff = nowTs - ts;
  if (diff < 60 * 1000) return '刚刚活跃';
  if (diff < 60 * 60 * 1000) return `${Math.floor(diff / (60 * 1000))} 分钟前活跃`;
  if (diff < 24 * 60 * 60 * 1000) return `${Math.floor(diff / (60 * 60 * 1000))} 小时前活跃`;
  return `${Math.floor(diff / (24 * 60 * 60 * 1000))} 天前活跃`;
}

export function formatOfflineAt(lastActiveAt) {
  if (!lastActiveAt) return '暂无离线时间';
  const ts = new Date(lastActiveAt);
  if (Number.isNaN(ts.getTime())) return '暂无离线时间';
  return ts.toLocaleString('zh-CN');
}

export function buildUserOnlineStatusView(userRow, currentUserId, formatLastActiveFn) {
  const isSelf = Boolean(currentUserId && userRow?.id === currentUserId);
  const isOnline = Boolean(userRow?.isOnline || isSelf);
  const activeTip = isSelf && !userRow?.lastActiveAt ? '当前登录用户' : formatLastActiveFn(userRow?.lastActiveAt);
  const offlineAt = formatOfflineAt(userRow?.lastActiveAt);
  const tip = isOnline ? activeTip : `离线时间：${offlineAt}`;
  return { isOnline, tip, offlineAt };
}

export function buildAuditRolePermissionRows(
  auditRoles = [],
  getPermissionSummaryFn,
  getOperationSummaryFn
) {
  return (Array.isArray(auditRoles) ? auditRoles : []).map((role) => ({
    id: role?.id || '',
    name: role?.name || '',
    permissionText: getPermissionSummaryFn(role?.id).join('、') || '—',
    operationText: getOperationSummaryFn(role?.id),
  }));
}
